import React from "react";
import CrudList from "@/components/CrudList";

export default function Shifts() {
  return (
    <CrudList
      title="Pembagian Shift"
      subtitle="Jadwal shift kerja karyawan (dapat diassign ke user)"
      endpoint="/shifts"
      auditEntity="shifts"
      columns={[
        { key: "name", label: "Nama Shift" },
        { key: "start_hour", label: "Mulai" },
        { key: "end_hour", label: "Selesai" },
        { key: "days", label: "Hari", render: (r) => (r.days || []).map((d) => ["Sen","Sel","Rab","Kam","Jum","Sab","Min"][d]).join(", ") || "-" },
      ]}
      fields={[
        { key: "name", label: "Nama Shift", required: true, placeholder: "Shift Pagi / Shift Malam", wide: true },
        { key: "start_hour", label: "Jam Mulai (HH:MM)", required: true, placeholder: "08:00" },
        { key: "end_hour", label: "Jam Selesai (HH:MM)", required: true, placeholder: "17:00" },
      ]}
    />
  );
}
